import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Typography,Button } from "@material-ui/core";
import { useStyles } from './styles';
import { getDocLanverDetails } from '../../actions';
import { scrollTop } from '../../helpers';
import CustomBreadcrum from '../Breadcrum';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

export const Documentcenter = () => {

  const classes = useStyles();
  const selectedAccount = useSelector(state => state.selectedAccount);
  const [content, setContent] = useState('')
  const privateLabelUrl = Cookies.get("privateLabelUrl")
  const isDocRequestAllowed = Cookies.get('isDocRequestAllowed');

  const getDocDetails = async (selectedAccount) => {
    const res = await getDocLanverDetails(selectedAccount);
    if (res) {
      setContent(res.url)
      scrollTop()
    }
  };

  useEffect(() => {
    if (selectedAccount) {
      getDocDetails(selectedAccount)
    }
    scrollTop()
  }, [selectedAccount]);

  return (
    <Box className={classes.rootBg}>
      <Box className={classes.root}>
        <CustomBreadcrum backPage="Home" backPageLink="/Dashboard" activePage="Documents" />
        { ((privateLabelUrl.toLowerCase() !== "aafmaa") && (isDocRequestAllowed == 'true') && (privateLabelUrl.toLowerCase() !== "point")) &&
        <Button className={classes.btn} size="large" fullWidth
                  variant='outlined'
                  component={Link} to='/DocumentRequest?back'
                >
                  REQUEST DOCUMENT
          </Button>
        }
        {content !== '' ?
          < Box className={classes.container} >
            <iframe className={classes.responsiveIframe} src={content}></iframe>
          </ Box>
          :
          <Box className={classes.loaderContainer}>
            <CircularProgress />
          </Box>
        }
      </Box>
    </Box>
  )
}